import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Draggable } from 'react-beautiful-dnd';

import {
  createCategoryAction,
  deleteCategoryAction,
  updateSubCategoryAction,
} from '../../../../../module/action/Category';
import Spinner from '../../../../../Constants/Spinner';
import LinesIcon from '../../../../../Assets/Icons/LinesIcon';
import EditIcon from '../../../../../Assets/Icons/EditIcon';
import DeleteIcon from '../../../../../Assets/Icons/DeleteIcon';
import TicIcon from '../../../../../Assets/Icons/TicIcon';
import { DraftIcon, PublishIcon } from '../../../../../Assets/Icons';
import ConfirmaModal from '../../../../../Constants/ConfirmModal';

const CategoryRow = ({
  addCatInTree,
  main,
  categoryTree,
  a,
  refId,
  bookID,
  index,
  key,
  editState,
  setEditState,
  setIdSelect,
  dndIndex,
}) => {
  const dispatch = useDispatch();
  const updateSubCategoryLoader = useSelector(e => e.Category.updateSubCategoryLoader);
  const createSubCategoryLoader = useSelector(e => e.Category.createSubCategoryLoader);
  const inputRef = useRef();

  const [catObj, setCatObj] = useState({
    bookId: bookID,
    category_name: '',
    typeCategory: 'Sub',
    refId: refId,
    chapterName: null,
  });

  useEffect(() => {
    setCatObj({
      ...a,
    });
  }, [a]);

  const save = () => {
    dispatch(createCategoryAction(catObj));
  };

  const clearStates = () => {
    setEditState('');
  };

  const [activeUpdateCategory, setActiveUpdateCategory] = useState(null);

  useEffect(() => {
    if (!updateSubCategoryLoader) {
      setNewStatus(null);
      setActiveUpdateCategory(null);
    }
  }, [updateSubCategoryLoader]);

  const [newStatus, setNewStatus] = useState(null);

  const handleUpdateCategory = status => {
    dispatch(updateSubCategoryAction(catObj, catObj._id, clearStates, status));
  };

  const update = (status = false) => {
    setActiveUpdateCategory(catObj._id);
    if (status) return setNewStatus(status);
    handleUpdateCategory(status);
  };

  const [deleteLoader, setDeleteLoader] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleDeleteDone = deleteLoading => {
    setDeleteLoader(deleteLoading);
    if (!deleteLoading) setDeleteModalOpen(false);
  };

  const deleteFn = () => {
    dispatch(
      deleteCategoryAction(catObj._id, catObj.typeCategory, bookID, handleDeleteDone, () => {
        setIdSelect(refId);
      })
    );
  };

  const categoryDrafted = catObj.status === 'draft';

  return (
    <>
      <Draggable key={a.index} draggableId={`${a.index}`} index={dndIndex ? dndIndex - 1 : index - 1}>
        {provided => (
          <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
            <div className="sm:w-[338px] w-[300px] sm:min-w-[338px] min-w-0" key={key}>
              <div
                className={`table-cell  h-[48px] py-2 pl-4 align-middle w-[50px] cursor-pointer ${
                  Object.keys(categoryTree).includes(String(a._id))
                    ? `border-[#2a9134] bg-[#DEEAE1] border-y-[1px] border-l-[1px]`
                    : `border-[#eef2f0] bg-white border-y-[1px]`
                }   rounded-s-[10px]`}
                onClick={() => {
                  if (a._id) {
                    addCatInTree(a, main, index, true);
                  }
                }}>
                <LinesIcon />
              </div>
              <div
                className={`table-cell h-[48px] py-2   align-middle w-[205px] ${
                  Object.keys(categoryTree).includes(String(a._id))
                    ? `border-[#2a9134] bg-[#DEEAE1] border-y-[1px] `
                    : `border-[#eef2f0] bg-white border-y-[1px]`
                }`}>
                <input
                  ref={inputRef}
                  value={catObj.category_name}
                  disabled={a._id ? editState != a._id : false}
                  dir="ltr"
                  className="urduText bg-transparent outline-none text-left font-bold text-[20px] leading-3 w-36"
                  style={{ textAlign: 'left' }}
                  onFocus={e => e.stopPropagation()}
                  onChange={ev => {
                    let obj = { ...catObj };
                    obj.category_name = ev.target.value;
                    setCatObj(obj);
                  }}
                />
              </div>
              <div
                className={`table-cell  h-[48px] py-2 pr-2  align-middle  ${
                  Object.keys(categoryTree).includes(String(a._id))
                    ? `border-[#2a9134] bg-[#DEEAE1] border-y-[1px] border-r-[1px]`
                    : `border-[#eef2f0] bg-white border-y-[1px]`
                } rounded-e-[10px]`}>
                <div className="flex items-center justify-end">
                  {editState && a._id && editState === a._id ? (
                    <button
                      disabled={updateSubCategoryLoader}
                      className="relative mr-2 flex items-center justify-center px-2 rounded-xl h-[32px] bg-[#2a9134] text-white"
                      onClick={() => update()}>
                      {updateSubCategoryLoader ? <Spinner /> : null}
                      <span
                        className={
                          updateSubCategoryLoader
                            ? `opacity-0 flex items-center justify-center`
                            : 'flex items-center justify-center'
                        }>
                        <TicIcon className="mr-1.5" stroke="#fff" />
                        Update
                      </span>
                    </button>
                  ) : a._id ? (
                    <>
                      <button
                        className="mr-2 flex items-center justify-center w-[32px] h-[32px] rounded-full bg-black"
                        onClick={() => {
                          setEditState(a._id);
                          inputRef.current.focus();
                        }}>
                        <EditIcon width={26} height={24} fill="#fff" />
                      </button>

                      <button
                        disabled={updateSubCategoryLoader && activeUpdateCategory}
                        className="relative flex items-center justify-center bg-black w-[32px] h-[32px] rounded-full mr-2"
                        onClick={() => update(categoryDrafted ? 'post' : 'draft')}>
                        {updateSubCategoryLoader && activeUpdateCategory ? <Spinner /> : null}
                        <span
                          className={` w-5 h-5 text-white ${
                            updateSubCategoryLoader && activeUpdateCategory && 'opacity-0'
                          }`}>
                          {categoryDrafted ? <PublishIcon /> : <DraftIcon />}
                        </span>
                      </button>

                      <button
                        disabled={deleteLoader}
                        className="relative flex items-center justify-center w-[32px] h-[32px] rounded-full bg-[#ca3030]"
                        onClick={() => setDeleteModalOpen(true)}>
                        {deleteLoader ? <Spinner /> : null}
                        <span
                          className={
                            deleteLoader
                              ? `opacity-0 flex items-center justify-center`
                              : 'flex items-center justify-center'
                          }>
                          <DeleteIcon svgProps={{ className: 'w-[20px] h-[20px]' }} pathProp={{ fill: '#fff' }} />
                        </span>
                      </button>
                    </>
                  ) : (
                    <button
                      disabled={createSubCategoryLoader}
                      className="relative mr-2 flex items-center justify-center px-2 rounded-xl h-[32px] bg-[#2a9134] text-white"
                      onClick={save}>
                      {createSubCategoryLoader ? <Spinner /> : null}
                      <span
                        className={
                          createSubCategoryLoader
                            ? `opacity-0 flex items-center justify-center`
                            : 'flex items-center justify-center'
                        }>
                        <TicIcon className="mr-1.5" stroke="#fff" />
                        Save
                      </span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </Draggable>

      <ConfirmaModal //
        open={newStatus}
        onOk={() => handleUpdateCategory(newStatus)}
        onCancel={() => {
          setNewStatus(null);
          setActiveUpdateCategory(null);
        }}
        loading={updateSubCategoryLoader}
        content={`Are you sure to change category status to ${categoryDrafted ? 'published' : 'draft'}?`}
        title="Change category status"
      />

      <ConfirmaModal //
        open={deleteModalOpen}
        onOk={deleteFn}
        onCancel={() => setDeleteModalOpen(false)}
        loading={deleteLoader}
        title="Delete category"
        content="Are you sure to delete the category?"
      />
    </>
  );
};
export default CategoryRow;
